import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lightning, GoogleLogo } from "@phosphor-icons/react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();

  if (user) {
    navigate("/marketplace", { replace: true });
    return null;
  }

  return (
    <div className="grid-bg min-h-[85vh] flex items-center justify-center px-5">
      <div className="relative w-full max-w-md">
        <div className="absolute -inset-6 bg-[#00E5FF]/10 blur-3xl rounded-full" />
        <div className="relative glass rounded-2xl p-10 text-center">
          <div className="w-14 h-14 bg-[#FFEB3B] flex items-center justify-center rounded-sm mx-auto mb-8">
            <Lightning weight="fill" size={30} className="text-[#05050A]" />
          </div>
          <h1 className="font-display font-black text-3xl uppercase tracking-tighter">Welcome to the club</h1>
          <p className="text-white/60 mt-4">
            Sign in to download packs, go premium, and heckle responsibly.
          </p>
          <button
            data-testid="google-login-btn"
            onClick={login}
            className="w-full flex items-center justify-center gap-3 bg-white text-[#05050A] font-bold py-4 rounded-sm mt-10 hover:bg-white/90 transition-colors"
          >
            <GoogleLogo weight="bold" size={22} /> Continue with Google
          </button>
          <p className="text-white/30 text-xs mt-6">
            By continuing you agree to laugh at least once.
          </p>
        </div>
      </div>
    </div>
  );
}
